import { Component } from '@angular/core';
import { selectCheckedServicesLength } from '@modules/booking/store/services';
import { Store } from '@ngrx/store';

@Component({
  selector: 'pub-proceed-footer',
  templateUrl: './proceed-footer.component.html',
  styleUrls: ['./proceed-footer.component.scss'],
})
export class ProceedFooterComponent {
  checkedServicesLength$ = this.store.select(selectCheckedServicesLength);

  constructor(private store: Store) {}
}
